/* 1) Benefits line under the price: back to the v48 version (emoji, bold lead,
      one short clause each).
   2) Trust block (14-day guarantee / Free worldwide shipping / Hassle-free
      returns): the emoji (shield, truck, return arrow) are swapped for clean
      line icons in brand orange. Text untouched. */
(function(){
var ITEMS=[
['\u26F7\uFE0F','Helmet friendly','goggles go straight over'],
['\u2744\uFE0F','Warm to \u221212\u00b0C','seals the neck gap'],
['\uD83D\uDE31','Reads as a real face','from ten feet away']
];
function build(){
var ul=document.getElementById('if-benefits');
if(!ul||ul.getAttribute('data-if-b4'))return false;
ul.setAttribute('data-if-b4','1');
ul.removeAttribute('data-if-b');ul.removeAttribute('data-if-b2');ul.removeAttribute('data-if-b3');ul.removeAttribute('data-if-b5');
ul.setAttribute('style','list-style:none; margin:0 0 16px; padding:0; display:flex; flex-direction:column; gap:7px;');
ul.innerHTML='';
ITEMS.forEach(function(it){
var li=document.createElement('li');
li.setAttribute('style','display:flex; align-items:baseline; gap:9px; font-size:14px; line-height:1.4; color:#3F4954;');
li.innerHTML='<span style="font-size:16px; line-height:1; flex-shrink:0;">'+it[0]+'</span><span><strong style="color:#12161C; font-weight:800;">'+it[1]+'</strong> &mdash; '+it[2]+'</span>';
ul.appendChild(li);
});
return true;
}
var SVG={
shield:'<path d="M12 2 4 5.5v6c0 4.6 3.2 8.9 8 10.5 4.8-1.6 8-5.9 8-10.5v-6L12 2z"/><path d="m9 12 2 2 4-4"/>',
truck:'<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>',
returns:'<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>'
};
var MAP=[[/\uD83D\uDEE1/,'shield'],[/\uD83D\uDE9A/,'truck'],[/\u21A9/,'returns']];
function icon(k){return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#FF4D14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="display:block;">'+SVG[k]+'</svg>';}
function trust(){
var root=document.getElementById('if');if(!root)return;
var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n,hits=[];
while((n=w.nextNode())){var t=n.nodeValue||'';for(var i=0;i<MAP.length;i++){if(MAP[i][0].test(t)){hits.push([n,MAP[i][1]]);break;}}}
hits.forEach(function(h){
var node=h[0],p=node.parentElement;if(!p||p.closest('#if-benefits,#if-gift-row,#if-shipbar'))return;
var box=p.closest('li,div');
if(!box||!/guarantee|shipping|returns/i.test(box.textContent||''))return;
var rest=(node.nodeValue||'').replace(/[\uD83D\uDEE1\uD83D\uDE9A\u21A9\uFE0F\u200D]/g,'').trim();
if(p.childNodes.length===1&&!rest){p.innerHTML=icon(h[1]);p.style.display='flex';p.style.alignItems='center';p.style.flexShrink='0';p.style.width='26px';p.style.height='26px';p.style.fontSize='0';p.setAttribute('data-if-ticon','1');}
else{var s=document.createElement('span');s.setAttribute('data-if-ticon','1');s.setAttribute('style','display:inline-flex; vertical-align:middle; margin-right:6px;');s.innerHTML=icon(h[1]);node.nodeValue=rest?(' '+rest):'';p.insertBefore(s,node);}
});
}
var n=0;
var iv=setInterval(function(){n++;build();trust();if(n>60)clearInterval(iv);},150);
setInterval(trust,1500);
if(document.readyState!=='loading'){build();trust();}else document.addEventListener('DOMContentLoaded',function(){build();trust();});
})();
